import React from 'react';

//component
import UserConfirmationModal from '../ConfirmationModal';
import ModalWrapper from '../ModalWrapper';


const ArchiveContentModal = ({showModal, hideModal, contentExistsInMultipleLocations, onArchiveItemClick} : {showModal: boolean, hideModal: () => void, contentExistsInMultipleLocations: boolean, onArchiveItemClick: () => void}) => {

    if (!showModal){
        return <></>
    }
    return (
        <ModalWrapper isOpen={showModal} onRequestClose={hideModal} className="archive-modal" children={
            <UserConfirmationModal confirmationModalVariables={{
                modalTitle: 'Archive',
                confirmationQuestion: contentExistsInMultipleLocations ? 'This content item exists in multiple places. You are permanently archiving the content from this location, others will remain published.' : `Are you sure you want to archive this item?`,
                leftButton: 'Cancel',
                rightButton: 'Confirm',
                modalClassName: 'notifications-confirmation-cms auto'
            }} onLeftButtonClick={hideModal} onRightButtonClick={onArchiveItemClick} modalClassName={'archive-content-modal'} />
            }   
        />
    );  
}

export default ArchiveContentModal;